// extracted by mini-css-extract-plugin
export default {"card":"G6-z"};